import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Dropdown,
  Form,
  FormControl,
  Pagination,
  Row,
} from "react-bootstrap";
import { dashboard_vertical_three_dots } from "../../../assets/images";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../../../services/apiConfig";
import axiosInstance from "../../../services/axios.instance";
import { useQuery } from "@tanstack/react-query";
import { ApiResponse, Invoice } from "../../../types";
import * as XLSX from "xlsx";
import DatePicker from "react-datepicker";
import { useForm } from "react-hook-form";

interface LocationData {
  latitude: string;
  longitude: string;
}

const ApprovedOrders = () => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("access_token");

  const decodeToken = (token: any) => {
    if (token) {
      return JSON.parse(atob(token.split(".")[1]));
    } else {
      return null;
    }
  };

  const decodedToken = decodeToken(accessToken);
  const merchantId =
    decodedToken && decodedToken["merchant-id"]
      ? decodedToken["merchant-id"]
      : null;

  const roles =
    decodedToken && decodedToken["roles"] ? decodedToken["roles"] : null;
  const showBranchColumn = roles?.includes("ROLE_MERCHANT_OPERATION");

  const {
    // control,
    formState: { isValid },
    setValue,
  } = useForm({ mode: "onChange" });

  const [currentPage, setCurrentPage] = useState(0);
  const [currentExportPage, setCurrentExportPage] = useState(0);
  const [currentSearchPage, setCurrentSearchPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchCriteria, setSearchCriteria] = useState("");
  const [searchResults, setSearchResults] = useState<ApiResponse | null>(null);
  const [showExportDateField, setShowExportDateField] = useState(false);
  const [exportDate, setExportDate] = useState("");
  const [showList, setShowList] = useState(false);
  const [exportList, setExportList] = useState<ApiResponse | null>(null);
  const [dateChange, setDateChange] = useState(false);
  const [searchType, setSearchType] = useState("date");
  const [searchValue, setSearchValue] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [insuranceFilter, setInsuranceFilter] = useState<string>("");
  const generatePageNumbers = (currentPage: number, totalPages: number) => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i);
    }

    if (currentPage <= 3) {
      return [0, 1, 2, 3, -1, totalPages - 2, totalPages - 1];
    }

    if (currentPage >= totalPages - 4) {
      return [
        0,
        1,
        -1,
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
      ];
    }

    return [
      0,
      1,
      -1,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      -1,
      totalPages - 1,
    ];
  };

  const fetchApprovedOrders = async (page: number) => {
    let url = `${API_URL.PURCHASE_ORDER}/${merchantId}?status=MERCHANT_ORDER_ACCEPT&page=${page}`;

    if (insuranceFilter === "insurance") {
      url += "&insurance-order=true";
    } else if (insuranceFilter === "non_insurance") {
      url += "&insurance-order=false";
    }

    const response = await axiosInstance.get(url);
    return response?.data;
  };

  const { data: approvedOrders } = useQuery<ApiResponse>({
    queryKey: ["approvedOrders", currentPage, insuranceFilter],
    queryFn: () => fetchApprovedOrders(currentPage),
  });

  // const handlePageChange = (page: number) => {
  //   setCurrentPage(page);
  //   fetchApprovedOrders(page);
  // };

  // const handlepageExportChange = (page: number) => {
  //   setCurrentExportPage(page);
  //   handleList(page);
  // };

  // const handlepageSearchChange = (page: number) => {
  //   setCurrentSearchPage(page);
  //   handleSearch(page);
  // };

  //======================================================================================

  //333333333333333333333333333333333333333333333333333

  const [visiblePages, setVisiblePages] = useState<number[]>(() => {
    const totalPages = approvedOrders?.totalPages || 0;
    return generatePageNumbers(0, totalPages);
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);

    const totalPages = approvedOrders?.totalPages || 0;

    if (totalPages >= 3) {
      const startPage = Math.floor(page / 3) * 3;
      const endPage = Math.min(startPage + 2, totalPages - 1);
      setVisiblePages(
        Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)
      );
    } else {
      setVisiblePages(Array.from({ length: totalPages }, (_, i) => i));
    }
  };

  useEffect(() => {
    if (approvedOrders?.totalPages) {
      setVisiblePages(
        generatePageNumbers(currentPage, approvedOrders.totalPages)
      );
    }
  }, [approvedOrders, currentPage]);

  //==========================================

  //--------------------------------------------------------------------------
  const [searchVisiblePages, setSearchVisiblePages] = useState<number[]>(() => {
    const totalPages = searchResults?.totalPages || 0;
    return generatePageNumbers(0, totalPages);
  });

  //-----------------------

  useEffect(() => {
    if (searchResults?.totalPages) {
      setSearchVisiblePages(
        generatePageNumbers(currentSearchPage, searchResults.totalPages)
      );
    }
  }, [searchResults, currentSearchPage]);

  // const handleSearchPageChange = (page: number) => {
  //   setSearchPage(page);
  // };
  const handlePageSearchChange = (page: number) => {
    setCurrentSearchPage(page);
    handleSearch(page);
  };

  //............................
  const [exportVisiblePages, setExportVisiblePages] = useState<number[]>(() => {
    const totalPages = exportList?.totalPages || 0;
    return generatePageNumbers(0, totalPages);
  });

  //-----------------------

  useEffect(() => {
    if (exportList?.totalPages) {
      setExportVisiblePages(
        generatePageNumbers(currentExportPage, exportList.totalPages)
      );
    }
  }, [exportList, currentExportPage]);

  const handlePageExportChange = (page: number) => {
    setCurrentExportPage(page);
    handleList(page);
  };

  //3333333333333333333333333333333333333333333333333333333333

  const [locationSearchQuery, setLocationSearchQuery] = useState<string>("");
  const [isLocationSelected, setIsLocationSelected] = useState(false);

  const [addressSuggestions, setAddressSuggestions] = useState<string[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<LocationData>({
    latitude: "0",
    longitude: "0",
  });
  const [selectedSuggestion, setSelectedSuggestion] = useState<string>("");

  const fetchLocationName = async (locationSearchQuery: string) => {
    const response = await fetch(
      `https://nominatim.kirkos.ae/search.php?q=${locationSearchQuery}&limit=5&format=json&addressdetails=1`
    );
    console.log(response, "wowww");
    const data = await response.json();
    const suggestions = data.map((item: any) => item.display_name);
    setAddressSuggestions(suggestions);
    const locationName = data?.display_name;
    return locationName;
  };

  // useQuery<string>({
  //   queryKey: ["locationName", locationSearchQuery],
  //   queryFn: () => fetchLocationName(locationSearchQuery),
  // });

  useQuery<string>({
    queryKey: ["locationName", locationSearchQuery],
    queryFn: () => fetchLocationName(locationSearchQuery),
    enabled: !isLocationSelected,
  });

  const handleSuggestionClick = async (selectedSuggestion: string) => {
    const response = await fetch(
      `https:///nominatim.kirkos.ae/search.php?q=${selectedSuggestion}&limit=5&format=json&addressdetails=1`
    );
    const data = await response.json();
    if (data.length > 0) {
      const { lat, lon } = data[0];
      setSelectedLocation({
        latitude: parseFloat(lat).toString(),
        longitude: parseFloat(lon).toString(),
      });
    }

    setSelectedSuggestion(selectedSuggestion);
    setLocationSearchQuery(selectedSuggestion);

    setValue("location", selectedSuggestion);
    setIsLocationSelected(true);
    setAddressSuggestions([]);
  };

  const handleLocationSearchChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLocationSearchQuery(event.target.value);
    setIsLocationSelected(false);
  };
  //===============================================================================================

  const handleExport = () => {
    setShowExportDateField(true);
  };
  const navigateToExportStatus = () => {
    navigate("/merchant/exportAllStatus");
  };
  //----------------------------------------------

  const handleList = async (page: number) => {
    const payload = {
      statuses: ["MERCHANT_ORDER_ACCEPT"],
      order_type: "DELIVERED",
      ...(searchType === "date" && {
        start_date: startDate,
        end_date: endDate,
      }),
      ...(searchType === "phone_number" && { phone_number: searchValue }),
      ...(searchType === "location" && {
        location: {
          latitude: selectedLocation.latitude,
          longitude: selectedLocation.longitude,
        },
      }),
    };

    try {
      const response = await axiosInstance.post(
        `${API_URL.EXPORTLIST_SEARCH_RESULTS}?page=${page}`,
        payload
      );
      setExportList(response?.data);
    } catch (error) {
      console.error("Error fetching search results", error);
    }
    // setExportDate("");
  };
  const fetchBranches = async () => {
    const response = await axiosInstance.get(
      `${API_URL.CHILD_BRANCHES}?merchantId=${merchantId}`
    );

    return response?.data || [];
  };
  const { data: branches } = useQuery<any>({
    queryKey: ["Branches"],
    queryFn: fetchBranches,
  });

  //-----------------------------------------------

  const handleExportSubmit = () => {
    if (exportList && exportList?.content?.length > 0) {
      const fileName = `ApprovedOrders_${exportDate}.xlsx`;

      const header = [
        "#",
        "Order Created Date",
        "Order Number",
        "LPO No",
        "Number of Days",
        "Customer Name",
        "Phone Number",
        "Product Name",
        "Location",
        "Extended days",
        "Plate Number",
        "Delivery Date and Time",
        "Recollection Date and Time",
        "Order Status",
      ];

      const exportData = exportList?.content?.map((invoice, index) => [
        index + 1,
        formatDate(invoice?.createdAt) ?? "",
        invoice?.orderId ?? "",
        invoice?.erp_service_number ?? "",
        invoice?.rental_days ?? "",
        invoice?.customer_name ?? "",
        invoice?.customer_phone_number ?? "",
        invoice?.products?.[0]?.productName ?? "",
        invoice?.delivery_location?.address ?? "",
        invoice?.extended_rental_days ?? "",
        invoice?.plate_number ?? "",
        formatDate(invoice?.delivery_date) ?? "",
        formatDate(invoice?.recollection_date) ?? "",
        invoice?.orderStatus ?? "",
      ]);

      const worksheet = XLSX.utils.aoa_to_sheet([header, ...exportData]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Order List");

      XLSX.writeFile(workbook, fileName);
    }
    setExportDate("");
    setShowList(false);
  };
  useEffect(() => {
    setSearchQuery("");
    setCurrentSearchPage(0);
  }, [searchCriteria]);

  const handleSearch = async (currentSearchPage: number) => {
    setCurrentPage(0);
    let date_filter_key = "";
    if (searchCriteria === "order_date") {
      date_filter_key = searchCriteria.toLowerCase().replace(" ", "_");
    }

    const payload = {
      order_number: searchCriteria === "order_number" ? searchQuery : "",
      date_filter_key: date_filter_key,
      date: searchCriteria === "order_date" ? searchQuery : "",
      insurance_claim: searchCriteria === "insurance_claim" ? searchQuery : "",
      erp_service_number:
        searchCriteria === "erp_service_number" ? searchQuery : "",
      customer_name: searchCriteria === "customer_name" ? searchQuery : "",
      customer_phone_number:
        searchCriteria === "customer_phone_number" ? searchQuery : "",
      merchant_id: searchCriteria === "merchant_id" ? searchQuery : "",
      count: 10,
      page: currentSearchPage,
      order_status_in: ["MERCHANT_ORDER_ACCEPT"],
    };

    try {
      const response = await axiosInstance.post(
        API_URL.SEARCH_RESULTS,
        payload
      );
      setSearchResults(response?.data);
    } catch (error) {
      console.error("Error fetching search results", error);
    }
  };

  const formatDate = (isoDate: any) => {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
  };
  const formatTime = (isoDate: string) => {
    if (!isoDate) return "-";
    const date = new Date(isoDate);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const dateFormatting = (date: Date | null, dateType: "start" | "end") => {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;
      if (dateType === "start") {
        setStartDate(formattedDate);
      } else {
        setEndDate(formattedDate);
      }
      setDateChange(true);
    } else {
      if (dateType === "start") {
        setStartDate("");
      } else {
        setEndDate("");
      }
    }
  };
  const handleSearchCriteriaChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSearchCriteria(e.target.value);
    setSearchQuery("");
  };

  const ordersToDisplay = searchResults?.content || approvedOrders?.content;

  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    setExportDate(formattedToday);
  }, []);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    if (
      (searchType === "date" && startDate && endDate) ||
      (searchType === "location" && locationSearchQuery.trim()) ||
      (searchType === "phone_number" && searchValue.trim())
    ) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [startDate, endDate, locationSearchQuery, searchValue, searchType]);

  // useEffect(() => {
  //   handleList();
  // }, [showExportDateField]);

  // useEffect(() => {
  //   if (dateChange) {
  //     handleList();
  //     seDateChange(false);
  //   }
  // }, [dateChange]);

  return (
    <div className="row">
      <div className="col-md-12 mb-3 mt-2">
        {!showExportDateField && (
          <Form.Group as={Row} className="align-items-center">
            <Col sm="3">
              <Form.Select
                className="custom-select"
                aria-label="Select search criteria"
                value={searchCriteria}
                onChange={handleSearchCriteriaChange}
              >
                <option value="">Search by</option>
                <option value="order_number">Order Number</option>
                <option value="order_date">Date</option>
                <option value="insurance_claim">Insurance Claim</option>
                <option value="erp_service_number">LPO Number</option>
                <option value="customer_name">Customer Name</option>
                <option value="customer_phone_number">Phone Number</option>
                <option value="merchant_id">Branch</option>
              </Form.Select>
            </Col>
            {!searchCriteria && (
              <Col sm="3">
                <Form.Select
                  className="custom-select"
                  value={insuranceFilter}
                  onChange={(e) => {
                    setInsuranceFilter(e.target.value);
                    setSearchResults(null);
                    setCurrentPage(0);
                  }}
                >
                  <option value="">All Orders</option>
                  <option value="insurance">AAA</option>
                  <option value="non_insurance">KIRKOS</option>
                </Form.Select>
              </Col>
            )}
            {searchCriteria && (
              <>
                <Col sm="5">
                  {searchCriteria === "merchant_id" ? (
                    <Form.Select
                      className="custom-select"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    >
                      <option value="">Select Branch</option>
                      {branches?.map((branch: any) => (
                        <option
                          key={branch?.merchant_id}
                          value={branch?.merchant_id}
                        >
                          {branch?.business_name}
                        </option>
                      ))}
                    </Form.Select>
                  ) : (
                    <FormControl
                      className="search-bar"
                      aria-label="Text input with select"
                      placeholder={
                        searchCriteria === "order_date"
                          ? "DD-MM-YYYY"
                          : "Enter your Search"
                      }
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  )}
                </Col>

                <Col sm="2">
                  <Button
                    className="search-button"
                    onClick={() => handleSearch(currentSearchPage)}
                  >
                    Search
                  </Button>
                </Col>
              </>
            )}
          </Form.Group>
        )}
        <Row className="justify-content-end">
          {!showExportDateField && !searchCriteria && (
            <Col sm="2" className="me-2">
              <Button
                variant="primary"
                className="btn all_button_style text-black my-1 w-100"
                onClick={handleExport}
              >
                Deliver
              </Button>
            </Col>
          )}
          {!showExportDateField && !searchCriteria && (
            <Col sm="2">
              <Button
                variant="primary"
                className="btn all_button_style text-black my-1 w-100"
                onClick={navigateToExportStatus}
              >
                Export
              </Button>
            </Col>
          )}
        </Row>
        {showExportDateField && (
          <Row className="mt-3">
            <Col sm="3">
              <Form.Select
                className="custom-select"
                value={searchType}
                onChange={(e) => setSearchType(e.target.value)}
              >
                <option value="date">Date</option>
                <option value="phone_number">Mobile Number</option>
                <option value="location">Location</option>
              </Form.Select>
            </Col>
            <Col sm="3">
              {searchType === "date" ? (
                <div className="d-flex gap-2">
                  <DatePicker
                    className="search-bar-export"
                    selected={startDate ? new Date(startDate) : null}
                    onChange={(date: Date | null) =>
                      dateFormatting(date, "start")
                    }
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Start Date"
                    customInput={
                      <input
                        readOnly
                        className="input-date"
                        placeholder="Start Date"
                        value={
                          startDate
                            ? startDate.split("-").reverse().join("-")
                            : ""
                        }
                      />
                    }
                    popperClassName="hide-calendar"
                    showPopperArrow={true}
                    autoComplete="off"
                  />
                  <DatePicker
                    className="search-bar-export"
                    selected={endDate ? new Date(endDate) : null}
                    onChange={(date: Date | null) =>
                      dateFormatting(date, "end")
                    }
                    dateFormat="dd-MM-yyyy"
                    placeholderText="End Date"
                    customInput={
                      <input
                        readOnly
                        className="input-date"
                        placeholder="End Date"
                        value={
                          endDate ? endDate.split("-").reverse().join("-") : ""
                        }
                      />
                    }
                    popperClassName="hide-calendar"
                    showPopperArrow={true}
                    autoComplete="off"
                    minDate={startDate ? new Date(startDate) : undefined}
                  />
                </div>
              ) : searchType === "location" ? (
                <div style={{ position: "relative" }}>
                  <FormControl
                    className="search-bar"
                    type="text"
                    placeholder="Enter Location"
                    value={locationSearchQuery}
                    onChange={handleLocationSearchChange}
                  //onChange={(e) => setLocationSearchQuery(e.target.value)}
                  />

                  {addressSuggestions.length > 0 && (
                    <div className="absolute-div">
                      <ul className="text-start" style={{ color: "white" }}>
                        {addressSuggestions.map((suggestion, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              handleSuggestionClick(suggestion);
                            }}
                          // onClick={() => {
                          //   setLocationSearchQuery(suggestion);
                          //   setAddressSuggestions([]);
                          // }}
                          >
                            {suggestion}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ) : (
                <FormControl
                  className="search-bar"
                  type="text"
                  placeholder="Enter Mobile Number"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  maxLength={9}
                />
              )}
            </Col>
            <Col sm="2">
              <Button
                className="btn all_button_style text-black my-1"
                onClick={() => handleList(currentPage)}
                disabled={isButtonDisabled}
              >
                Search List
              </Button>
            </Col>
            {exportList && (
              <Col sm="2">
                <Button
                  className="btn all_button_style text-black my-1"
                  onClick={handleExportSubmit}
                  disabled={exportList?.content?.length === 0}
                >
                  Export
                </Button>
              </Col>
            )}

            <Col sm="2">
              <Button
                className="btn all_button_style text-black my-1"
                variant="danger"
                onClick={() => {
                  setShowExportDateField(false);
                  setStartDate("");
                  setEndDate("");
                  setLocationSearchQuery("");
                  setSearchValue("");
                  setShowList(false);
                  setExportList(null);
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        )}
      </div>

      <div className="col-md-12 dashboard-table-div">
        <table className="table table-hover dashboard-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Order Number</th>
              <th>ERP No</th>
              {showBranchColumn && <th>Branch</th>}
              <th>Number of Days</th>
              <th>Customer Name</th>
              <th>Phone Number</th>
              <th>Product Name</th>
              <th>Location</th>
              <th>Date</th>
              <th>Time</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {exportList
              ? exportList?.content?.map((invoice: Invoice, index: number) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{invoice?.orderId}</td>
                  <td>{invoice?.erp_service_number}</td>

                  {showBranchColumn && <td>{invoice?.merchantName}</td>}

                  <td>{invoice?.rental_days}</td>
                  <td>{invoice?.customer_name}</td>
                  <td>{invoice?.customer_phone_number}</td>
                  <td>{invoice?.products?.[0]?.productName}</td>
                  <td>{invoice?.delivery_location?.address}</td>
                  <td>
                    <span className="invoice-date-td">
                      {formatDate(invoice?.delivery_date)}
                    </span>
                  </td>
                  <td>
                    <span className="invoice-date-td">
                      {formatTime(invoice?.delivery_date)}
                    </span>
                  </td>
                  <td>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                        className="Dropdown-table"
                      >
                        <img
                          src={dashboard_vertical_three_dots}
                          width="15"
                          height="15"
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="Dropdown-table-item">
                        <Dropdown.Item
                          as={Link}
                          to={`/merchant/accepted/details?OrderId=${invoice.orderId}`}
                          className="Dropdown-table-list Dropdown-table-border-top Dropdown-table-item-link"
                        >
                          View Details
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to={`/merchant/accepted/assign?OrderId=${invoice.orderId}`}
                          className="Dropdown-table-list Dropdown-table-item-link"
                        >
                          Assign
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to={`/merchant/accepted/edit?OrderId=${invoice.orderId}`}
                          className="Dropdown-table-list Dropdown-table-border-bottom Dropdown-table-item-link"
                        >
                          Edit
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))
              : ordersToDisplay?.map((invoice: Invoice, index: number) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{invoice?.orderId}</td>
                  <td>{invoice?.erp_service_number}</td>
                  {showBranchColumn && <td>{invoice?.merchantName}</td>}
                  <td>{invoice?.rental_days}</td>
                  <td>{invoice?.customer_name}</td>
                  <td>{invoice?.customer_phone_number}</td>
                  <td>{invoice?.products?.[0]?.productName}</td>
                  <td>{invoice?.delivery_location?.address}</td>
                  <td>
                    <span className="invoice-date-td">
                      {formatDate(invoice?.delivery_date)}
                    </span>
                  </td>
                  <td>
                    <span className="invoice-date-td">
                      {formatTime(invoice?.delivery_date)}
                    </span>
                  </td>
                  <td>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                        className="Dropdown-table"
                      >
                        <img
                          src={dashboard_vertical_three_dots}
                          width="15"
                          height="15"
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="Dropdown-table-item">
                        <Dropdown.Item
                          as={Link}
                          to={`/merchant/accepted/details?OrderId=${invoice.orderId}`}
                          className="Dropdown-table-list Dropdown-table-border-top Dropdown-table-item-link"
                        >
                          View Details
                        </Dropdown.Item>
                        {!showBranchColumn && (
                          <Dropdown.Item
                            as={Link}
                            to={`/merchant/accepted/assign?OrderId=${invoice.orderId}`}
                            className="Dropdown-table-list Dropdown-table-item-link"
                          >
                            Assign
                          </Dropdown.Item>
                        )}
                        <Dropdown.Item
                          as={Link}
                          to={`/merchant/accepted/edit?OrderId=${invoice.orderId}`}
                          className="Dropdown-table-list Dropdown-table-border-bottom Dropdown-table-item-link"
                        >
                          Edit
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {!searchResults && !exportList && approvedOrders && (
          <Pagination className="pagination-align">
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 0}
            />
            {visiblePages.map((pageNum, index) =>
              pageNum === -1 ? (
                <Pagination.Ellipsis key={`ellipsis_${index}`} />
              ) : (
                <Pagination.Item
                  key={pageNum}
                  active={pageNum === currentPage}
                  onClick={() => handlePageChange(pageNum)}
                >
                  {pageNum + 1}
                </Pagination.Item>
              )
            )}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === (approvedOrders?.totalPages || 0) - 1}
            />
          </Pagination>
        )}

        {exportList && (
          <Pagination className="pagination-align">
            <Pagination.Prev
              onClick={() => handlePageExportChange(currentExportPage - 1)}
              disabled={currentExportPage === 0}
            />
            {exportVisiblePages.map((pageNum, index) =>
              pageNum === -1 ? (
                <Pagination.Ellipsis key={`ellipsis_${index}`} />
              ) : (
                <Pagination.Item
                  key={pageNum}
                  active={pageNum === currentExportPage}
                  onClick={() => handlePageExportChange(pageNum)}
                >
                  {pageNum + 1}
                </Pagination.Item>
              )
            )}
            <Pagination.Next
              onClick={() => handlePageExportChange(currentExportPage + 1)}
              disabled={currentExportPage === (exportList?.totalPages || 0) - 1}
            />
          </Pagination>
        )}

        {searchResults && (
          <Pagination className="pagination-align">
            <Pagination.Prev
              onClick={() => handlePageSearchChange(currentSearchPage - 1)}
              disabled={currentSearchPage === 0}
            />
            {searchVisiblePages.map((pageNum, index) =>
              pageNum === -1 ? (
                <Pagination.Ellipsis key={`ellipsis_${index}`} />
              ) : (
                <Pagination.Item
                  key={pageNum}
                  active={pageNum === currentSearchPage}
                  onClick={() => handlePageSearchChange(pageNum)}
                >
                  {pageNum + 1}
                </Pagination.Item>
              )
            )}
            <Pagination.Next
              onClick={() => handlePageSearchChange(currentSearchPage + 1)}
              disabled={
                currentSearchPage === (searchResults?.totalPages || 0) - 1
              }
            />
          </Pagination>
        )}
      </div>
    </div>
  );
};

export default ApprovedOrders;
